<template lang="pug">
  .menuBtn
    v-menu.theMenu(open-on-hover :bottom="fromMenu" :offset-y="fromMenu" :right="fromDrawer" :offset-x="fromDrawer")
      template(v-slot:activator='{ on }')
        v-btn.noCursor(v-on="on",text :class="{'v-btn--active': isActive}") Media
          
      v-list.theList(color="#3C8C40",dark )
        v-list-item(v-for='(item, index) in items' :key='index' :to="item.path" @click="updateRootPage")
          v-list-item-title {{ item.title }}
</template>
<script>
export default {
  props: ['fromDrawer', 'fromMenu'],
  data: () => ({
    items: [
      { title: 'Live Service', path: '/media/live-service' },
      { title: 'Social', path: '/media/social' }
    ]
  }),
  methods: {
    updateRootPage() {
      this.$store.commit('setRoot', 'media');
    }
  },
  computed: {
    isActive() {
      let theRoot = this.$store.getters.getRoot;
      console.log('TCL: isActive -> theRoot', theRoot);
      return theRoot == 'media' ? true : false;
    }
  }
};
</script>
